import { BaseService } from "@flint/framework";

export default class EPubDeleteData extends BaseService {
  constructor() {
    super("DELETING_EPUB_DATA","EPubDeleteResStore",true);
  }

  handleEvent = (eventName, ePubISBN) => {
    return this.getClient("vetService").delete(`/admin-api/epubs/${ePubISBN}`)
  };
}
